import React , { useState } from 'react';
import AuthService from 'js/Services/Auth/AuthService.js';
import { v4 as uuidv4 } from 'uuid';
import AccessTokenCookie from 'js/Services/Auth/Model/Identity/AccessTokenCookie.js';
import UserPerson from 'js/Services/Auth/Model/User/UserPerson.js';


const Reducer = ( authService ) => {
    let reducer = {};
    reducer.getAuthService = function() {
        return authService;
    };

    return reducer;
};

const useAuth = function( initialData ) {
    const [ stateChangeTrigger , setStateChangeTrigger ] = useState('1');
    const [ initialized , setInitialized ] = useState(false);
    const [ authService , setAuthService ] = useState(() => {
        let authService = new AuthService() ;
        // if( initialData.currentIdentity && initialData.currentIdentity.type == 'AccessTokenCookie'   ){
        //     const user = new UserPerson( initialData.currentIdentity.user.id , initialData.currentIdentity.user.firstname , initialData.currentIdentity.user.lastname , initialData.currentIdentity.user.email );
        //     user.setManagingSuppliers(initialData.currentIdentity.user.managingSuppliers);
        //     const identity = new AccessTokenCookie( initialData.currentIdentity.token , user );
        //     authService.setCurrentIdentity(identity);
        //     authService.markInitialized();
        // } else if ( initialData.currentIdentity !== undefined) {
        //     authService.markInitialized();
        // }
        return authService;
    });
    authService.setStateChangeCallback( ()=>{ setStateChangeTrigger(uuidv4()); });
    if( !initialized ){
        authService.setOnInitialized( ()=>{ setInitialized(true); });
    }

    return [
        authService.isInitialized() , // initialized
        authService.getCurrentIdentity() , // currentIdentity
        authService
    ] ;
}


export  default useAuth  ;
